// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-title-container","borderRandomizer":"partials-title-borderRandomizer"};